var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-view',{staticClass:"text-center",attrs:{"title":_vm.$t('expired.title'),"message":_vm.getMessage(),"footer":_vm.$t('expired.expired-range', {
      start: _vm.friendlyStartDate,
      end: _vm.friendlyExpirationDate
    })}})}
var staticRenderFns = []

export { render, staticRenderFns }